import { Component, Input, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { ContractRequest } from 'ng2-app/services/contract-requests/contract-request.model';
import { ContractRequestService } from 'ng2-app/services/contract-requests/contract-request.service';
import { Deal } from 'ng2-app/models/dto/deal.model';
import { EventBusService } from 'ng2-app/modules/shared/services/event-bus.service';


@Component({
  selector: 'contract-request-details',
  templateUrl: 'contract-request-details.component.html',
  styleUrls: ['contract-request-details.component.scss'],
})
export class ContractRequestDetailsComponent implements OnInit {

  @Input() contract_request: ContractRequest;
  @Input() deal: Deal;
  @Input() canEditContractRequests: boolean;
  @Input() sending: boolean = false;
  @Output() newItemEvent = new EventEmitter<void>();

  signersFormatted: any;
  contractRequestProductType: string;

  paymentFrequencyOptionNames = {
    biWeekly: 'Every Two Weeks',
    daily: 'Daily',
    monthly: 'Monthly',
    weekly: 'Weekly',
  };

  constructor(
    private eventBusService: EventBusService,
    private contractRequestService: ContractRequestService,
  ) { }

  ngOnInit() {
    this.signersFormatted = this.contract_request.signers?.map(signer => signer.email)
      .join(', ');
    this.contractRequestProductType = this.deal?.loan_product.category.shortName.toUpperCase() || 'ACH';
  }

  edit() {
    this.newItemEvent.emit();
  }
}
